import alt from 'framework/alt';

class ProfileImageActions {
  constructor() {
    this.generateActions(
      'createSucceeded',
      'createFailed',
      'deleteSucceeded',
      'deleteFailed',
      'fetchSucceeded',
      'fetchFailed',
    );
  }
}

export default alt.createActions(ProfileImageActions);
